module.exports = __webpack_public_path__ + "static/media/cloud--orange.29615283.svg";